import { line, curveLinear } from "d3-shape"
import { axisLeft } from "d3-axis"
import { createSelector } from "reselect"
import { find } from "lodash"
import { MARGINS, getHeight, getScaleX, getTotalTickFormat, getWidth, getTotalScaleY } from "."
import { getTotalData } from "./data"
import { getTotalItem } from "./items"

export const getTotalLine = createSelector(
  [getScaleX, getTotalScaleY, getTotalData, getTotalItem],
  (scaleX, scaleY, data, item) => {
    if (item.length) {
      const { id, color } = item[0]
      return {
        id,
        d: line()
          .x(d => scaleX(d.date))
          .y(d => scaleY(d[id]))
          .curve(curveLinear)(data),
        style: { stroke: color },
      }
    }

    return null
  },
)

export const getTotalYAxis = createSelector(
  [getHeight, getWidth, getTotalScaleY, getTotalTickFormat],
  (height, width, scaleY, tickFormat) => ({
    fn: axisLeft()
      .scale(scaleY)
      .tickSize(-width + MARGINS.left + MARGINS.right)
      .tickFormat(tickFormat),
    transform: `translate(${MARGINS.left},0)`,
    labelTransform: {
      x: 0,
      y: height / 2,
    },
    baseline: {
      x1: MARGINS.left,
      x2: MARGINS.left,
      y1: MARGINS.top,
      y2: height - MARGINS.bottom,
    },
  }),
)

export const getFindTotalByOffset = createSelector(
  [getTotalData, getScaleX],
  (data, scaleX) => offset => {
    const lookup = scaleX.invert(offset - 18) // -2 is to give a margin of selection on the first element, -16 for the margin
    return find(data, datum => datum.date >= lookup)
  },
)
